import { makeAutoObservable, reaction } from "mobx";
import RootStore from "stores/RootStore";
// import GenerateData from 'shared/generators/GenerateData'; // Adjust the path as necessary
import { utils } from "@intrasync/utils";
import ServiceStore from "stores/ServiceStore";
import { getDateRange, getLastWorkday, getNextWorkday } from "@intrasync/utils";
import ProductionScheduleRightHeaderCell from "./ProductionScheduleCells/ProductionSchedule.RightHeaderCell";
import ProductionScheduleRightBodyCell from "./ProductionScheduleCells/ProductionSchedule.RightBodyCell";
import ProductionScheduleLeftHeaderCell from "./ProductionScheduleCells/ProductionSchedule.LeftHeaderCell";
import ProductionScheduleLeftBodyCell from "./ProductionScheduleCells/ProductionSchedule.LeftBodyCell";

interface PanelEntity {
  [key: string]: string;
}

class ProductionScheduleStore {
  rootStore: RootStore;

  showMu = false;

  currentlySelectedEntities: number[] = [];

  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    reaction(
      () =>
        this.entities.map((entity) => {
          return { ...entity };
        }),
      () => {
        if (!this.productionScheduleActive) return null;
        // console.log('reaction entities', this.entities);
        // console.log(
        //   'this.rootStore.scheduleGridStore?.namespaces',
        //   this.rootStore.scheduleGridStore?.namespaces
        // );
        if (this.rootStore.scheduleGridStore?.namespaces?.ProductionSchedule) {
          this.rootStore.scheduleGridStore?.namespaces?.ProductionSchedule.recomputeScheduler();
          // console.log('ProductionSchedule recomputeScheduler');
        }
      }
    );
  }

  toggleShowMu = () => {
    this.showMu = !this.showMu;
  };

  setCurrentlySelectedEntities = (entityId: number) => {
    const foundIndex = this.currentlySelectedEntities.findIndex(
      (currentEntityId) => currentEntityId === entityId
    );

    console.log("foundIndex", foundIndex);

    if (foundIndex !== -1) {
      this.currentlySelectedEntities = this.currentlySelectedEntities.filter(
        (currentEntityId) => currentEntityId !== entityId
      );

      return;
    }

    this.currentlySelectedEntities = [
      ...this.currentlySelectedEntities,
      entityId,
    ];
  };

  moveCurrentlySelectedEntities = (direction: "up" | "down") => {
    const panelStore = this.rootStore.panelStore as ServiceStore;
    if (!panelStore) {
      return;
    }
    const currentlySelectedEntities: PanelEntity[] = this.entities.filter(
      (entity: PanelEntity) =>
        this.currentlySelectedEntities.includes(entity.id as unknown as number)
    );

    if (currentlySelectedEntities.length === 0) {
      return;
    }

    const groupedByDate = utils.groupBy(
      currentlySelectedEntities,
      "castingDate"
    );
    const sortedDates = Object.keys(groupedByDate).sort();

    if (direction === "up") {
      sortedDates.forEach((date) => {
        const currentEntities = groupedByDate[date];
        const dateBefore = getLastWorkday(date);
        const includedIds = currentEntities.map((entity) => entity.id);
        console.log("includedIds", includedIds);

        panelStore?.patch(
          null,
          {
            castingDate: dateBefore,
          },
          {
            query: {
              id: {
                $in: includedIds,
              },
            },
          }
        );
      });
    } else {
      sortedDates.forEach((date) => {
        const currentEntities = groupedByDate[date];
        const dateAfter = getNextWorkday(date as string);
        const includedIds = currentEntities.map((entity) => entity.id);
        console.log("includedIds", includedIds);

        panelStore?.patch(
          null,
          {
            castingDate: dateAfter,
          },
          {
            query: {
              id: {
                $in: includedIds,
              },
            },
          }
        );
      });
    }
  };

  clearCurrentlySelectedEntities = () => {
    this.currentlySelectedEntities = [];
  };

  getRowHeight = (index: number): number => {
    // console.log('getRowHeight index', index);
    const modifiedIndex = index - 1; // Add 1 to account for the date row
    // console.log('getRowHeight modifiedIndex', modifiedIndex);
    if (this.dateRange.length === 0) {
      return 50;
    }
    const date = this.dateRange[modifiedIndex];
    // console.log('getRowHeight row', row);
    const dateEntities = this.entities.filter(
      (entity) => entity.castingDate === date
    );
    // console.log('dateEntities', dateEntities);
    const moldCounts: { [moldNumber: string]: number } = {};
    dateEntities.forEach((entity) => {
      const moldNumber = entity.moldNumber as string;
      if (moldNumber) {
        moldCounts[moldNumber] = (moldCounts[moldNumber] || 0) + 1;
      }
    });

    // console.log('moldCounts', moldCounts);

    // let mostFrequentMoldNumber: string | null = null;
    let maxCount = 0;

    for (const moldNumber in moldCounts) {
      if (moldCounts[moldNumber] > maxCount) {
        // mostFrequentMoldNumber = moldNumber;
        maxCount = moldCounts[moldNumber];
      }
    }

    if (maxCount >= 2 && maxCount <= 4) {
      // console.log('getRowHeight date', date);
      // console.log('mostFrequentMoldNumber', mostFrequentMoldNumber);
      // console.log('maxCount', maxCount);
      const rowHeight = maxCount * 52;
      // console.log('rowHeight', rowHeight);
      return rowHeight;
    }
    if (maxCount > 4) {
      // console.log('getRowHeight date', date);
      // console.log('mostFrequentMoldNumber', mostFrequentMoldNumber);
      // console.log('maxCount', maxCount);
      const rowHeight = maxCount * 51;
      // console.log('rowHeight', rowHeight);
      return rowHeight;
    }
    return 54;
  };

  get currentEntitiesMolds() {
    return utils.sortByMold(
      utils.uniqueArray(
        this.entities.map((entity) => entity.moldNumber as string)
      ) as string[]
    );
  }

  get columnHeaders() {
    // console.log(
    //   'Getting column headers this.currentEntitiesMolds',
    //   this.currentEntitiesMolds
    // );
    const headersByMold = this.currentEntitiesMolds
      .filter((mold) => {
        if (!mold) {
          return false;
        }
        if (mold === "0") {
          return false;
        }
        if (mold.includes("MU")) {
          return false;
        }
        if (mold.includes("FBF")) {
          return false;
        }
        return true;
      })
      .map((mold) => {
        return {
          width: 230,
          title: mold,
          key: mold,
          headerKey: "moldNumber",
          component: ProductionScheduleRightHeaderCell,
          bodyComponent: ProductionScheduleRightBodyCell,
        };
      });

    return [
      {
        width: 130,
        title: "Date",
        key: "castingDate",
        component: ProductionScheduleLeftHeaderCell,
        bodyComponent: ProductionScheduleLeftBodyCell,
      },
      ...headersByMold,
    ];
  }

  get entities(): PanelEntity[] {
    const routerStore = this.rootStore.routerStore;
    const panelStore = this.rootStore.panelStore as ServiceStore;
    if (!routerStore) return [];
    const { params } = routerStore;
    if (!params?.jobNumber) return [];
    const currentEntities = panelStore.entities
      .filter((entity) => {
        if (!entity.jobNumber) {
          // console.log('NO JOB NUMBER', panelPlantItem);
          return false;
        }
        return utils.isSameJobNumber(
          entity.jobNumber as number,
          params?.jobNumber as number
        );
      })
      .filter((entity) => {
        if (!entity.castingDate) {
          // console.log('NO CASTING DATE', panelPlantItem);
          return false;
        }
        return entity.castingDate !== "1970-01-01";
      })
      .filter((entity) => {
        if (!entity.moldNumber) {
          // console.log('NO MOLD NUMBER', panelPlantItem);
          return false;
        }
        return entity.moldNumber !== "0";
      })
      .filter((entity) => {
        if (
          !this.showMu &&
          entity?.moldNumber &&
          typeof entity.moldNumber === "string" &&
          (entity?.moldNumber?.includes("MU") ||
            entity?.moldNumber?.includes("FBF"))
        ) {
          return false;
        }
        return true;
      });
    // console.log('ProductionScheduleStore entities', currentEntities);
    return currentEntities as PanelEntity[];
  }

  get dateRange() {
    if (this.entities.length === 0) {
      return [];
    }
    const dates = this.entities
      .filter(
        (entity) => entity.castingDate && entity.castingDate !== "1970-01-01"
      )
      .map((entity) => entity.castingDate as string)
      .sort();

    const startDate = dates[0];
    const endDate = dates[dates.length - 1];

    if (!startDate || !endDate) {
      return [];
    }

    // console.log('ProductionScheduleStore dateRange dates', dates);

    return getDateRange(startDate, endDate, { weekdays: true });
  }

  get productionScheduleActive() {
    return this.rootStore.scheduleGridStore?.namespaces?.ProductionSchedule
      ? true
      : false;
  }
}

export default ProductionScheduleStore;
